import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
declare const posthog: any;

@Injectable({
    providedIn: 'root',
})
export class PostHogService {
    constructor() {
        posthog.init(environment.posthog.token, {
            api_host: 'https://eu.i.posthog.com',
            person_profiles: 'identified_only',
            capture_pageview: false,
            capture_pageleave: false,
        });
    }

    logIn(userId: string | null) {
        if (userId !== null) {
            posthog.identify(userId);
        }
    }

    logOut() {
        posthog.reset();
    }

    captureEvents(eventName: string, attributes?: any) {
        if (postHogAllowedEvents.includes(eventName)) {
            posthog.capture(eventName, attributes);
        }
    }

    setUserAttributes(user: any) {
        if (!user) {
            return;
        }

        const name = user.name?.trim();
        const nameSegments = name?.split(' ') || [];

        const properties = {
            ...(user.email && { email: user.email.trim() }),
            ...(user.birthday && {
                birthday: new Date(user.birthday).toLocaleDateString(),
            }),
            ...(name && { name }),
            ...(nameSegments[0] && { firstName: nameSegments[0] }),
            ...(nameSegments.length > 1 && {
                lastName: nameSegments.slice(1).join(' '),
            }),
            ...(user.phone && { phone: user.phone }),
        };

        posthog.setPersonProperties(properties);
    }
}

export const postHogAllowedEvents = [
    'register',
    'add_address',
    'view_cart',
    'begin_checkout',
    'add_payment_info',
    'purchase',
    'payment-failed',
];
